import Vue from 'vue'
import router from '@/router'
import store from '@/store'
import App from '@/App'
import cachedState from '@/cachedState'
import initCommerceEvents from '@/analytics/commerce-events/init'

// Close modals when a link is clicked. Could have used router's beforeEach, but this would not work when we're already
// on that route (e.g. when we click 'Go to catalog' on the modal and it was closed on that page).
// TODO can we somehow only add this mixin only to `<router-link>`s?
// Adding variables for performance.
const uiModuleState = store.state.ui;
const storeCommit = store.commit;

function closeModals() {
  if (uiModuleState.authModalIsActive) {
    storeCommit('ui/toggleAuthModal');
  }

  if (uiModuleState.cartModalIsActive) {
    storeCommit('ui/toggleCartModal');
  }
}

function shouldCloseModalsOnLick(instance) {
  if (instance.$options.name !== 'RouterLink') {
    return false;
  }

  const target = instance.$attrs.target;

  if (target === '_blank') {
    return false;
  }

  if (process.env.NODE_ENV !== 'production' && target !== undefined) {
    console.warn('It was assumed that `target` of `<router-link>` can only be `undefined` or `"_blank"`.' +
      ' Found other value being used.');
  }

  return true;
}

Vue.mixin({
  mounted() {
    if (shouldCloseModalsOnLick(this)) {
      this.$el.addEventListener('click', closeModals);
    }
  },

  beforeDestroy() {
    if (shouldCloseModalsOnLick(this)) {
      this.$el.removeEventListener('click', closeModals);
    }
  },
})

const app = new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    analytics: {
      yandexMetrika: null,
      facebookPixel: null,
      vkPixel: null,
      commerceEvents: null,
    },
    sharedEventBus: new Vue(),
  },
  mounted() {
    this.$store.dispatch('auth/initUser')
    this.$store.dispatch('store/preloadStoreFromStorage')
    this.$store.dispatch('catalog/preloadCategoriesFromStorage')

    this.$store.dispatch('store/loadStore').then(store => {
      if (!cachedState.prerendering()) {
        this.$store.dispatch('order/initOrder')
      }

      if (!store || !store.settings) {
        return
      }

      this.$store.dispatch('offers/loadOffers', this.$store.getters['store/activeCityId']);
      if (store.settings.recaptcha) {
        this.$store.dispatch('recaptcha/init', store.settings.recaptcha)
      }

      if (store.settings.websockets) {
        this.$store.dispatch('broadcast/init', { settings: store.settings.websockets, app: this })
          .then(echo => {
            console.log('Got pusher connection.', echo)
          })
          .catch(() => {})
      }
    })

    this.$store.dispatch('catalog/loadCategoriesTree')

    initCommerceEvents(app)

    if (this.$store.getters['settings/yandexMetrika'].id) {
      import('@/analytics/yandex-metrika/init').then(module => module.default(app));
    }

    if (this.$store.getters['settings/facebookPixel'].id) {
      import('@/analytics/facebook/init').then(module => module.default(app))
    }

    if (this.$store.getters['settings/vkPixel'].id) {
      import('@/analytics/vk/init').then(module => module.default(app))
    }
  },
})

export default app
